import {
  FETCH_VEHICULO_INFO,
} from './actions.type';

import {
  SET_ERROR,
  FETCHING_VEHICULO,
  FETCHED_VEHICULO,
} from './mutations.type';
// eslint-disable-next-line import/no-cycle
import ApiService from '../common/api.service';

/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
  // vehiculo_info: {},
  loading_vehiculo: false,
  processing_vehiculo: false,
};

const getters = {
  is_loading() {
    return state.loading_vehiculos;
  },
  /*
  vehiculo_info() {
    return state.vehiculo_info;
  },
  */
  vehiculo_processing() {
    return state.processing_vehiculo;
  },
};

const actions = {
  [FETCH_VEHICULO_INFO](context, vehiculoId) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_VEHICULO);
      const url = `vehiculos/${vehiculoId}`;
      ApiService.query(url)
        .then(({ data }) => {
          context.commit(FETCHED_VEHICULO);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_VEHICULO);
        });
    });
  },
};

const mutations = {
  [FETCHING_VEHICULO](state) {
    state.loading_vehiculo = true;
  },
  [FETCHED_VEHICULO](state) {
    state.loading_vehiculo = false;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
